import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center p-6 animate-fade-in">
      <div className="text-center max-w-sm">
        <div className="text-8xl mb-6" style={{ filter: 'drop-shadow(0 0 30px rgba(0,212,255,0.3))' }}>🏟</div>
        <h1 className="section-title text-6xl mb-2" style={{ color: 'var(--ice)' }}>404</h1>
        <p className="text-xl font-semibold mb-2">Puck's gone missing</p>
        <p className="text-secondary text-sm mb-8">
          The page you're looking for doesn't exist.
        </p>
        <div className="flex gap-3 justify-center">
          <button onClick={() => navigate(-1)} className="btn-ghost border border-white/10">
            ← Go back
          </button>
          <button onClick={() => navigate('/dashboard')} className="btn-ice">
            Back to Rink
          </button>
        </div>
      </div>
    </div>
  );
}
